__turbopack_context__.v({
  "cta": "landing-module__4LXPma__cta",
  "freeCard": "landing-module__4LXPma__freeCard",
  "headline": "landing-module__4LXPma__headline",
  "hero": "landing-module__4LXPma__hero",
  "look": "landing-module__4LXPma__look",
  "lookNumber": "landing-module__4LXPma__lookNumber",
  "looks": "landing-module__4LXPma__looks",
  "paidCard": "landing-module__4LXPma__paidCard",
  "proof": "landing-module__4LXPma__proof",
  "proofBody": "landing-module__4LXPma__proofBody",
  "proofHeader": "landing-module__4LXPma__proofHeader",
  "sectionTitle": "landing-module__4LXPma__sectionTitle",
});
